const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 5 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={'dB fillCT>circle ' + (props.className || '')}
    >
      <circle cx="2.5" cy="2.5" r="2.5"/>
      <circle cx="2.5" cy="11.5" r="2.5"/>
      <circle cx="2.5" cy="20.5" r="2.5"/>
    </svg>
  );
};
